import { initFaro, setFaroUser, clearFaroUser } from "./faro";
import { initSentry, setSentryUser, clearSentryUser } from "./sentry";

export { getTraceId } from "./sentry";
export { pushFaroEvent, getFaroSessionId } from "./faro";
export { scrubPhi } from "./phi-scrubber";
export { trackBillingEvent } from "./events";

export function initObservability() {
  initSentry();
  initFaro();
}

/**
 * Set user + org context on both Sentry and Faro.
 * Call after successful login or session restore.
 */
export function setObservabilityUser(userId: string, orgId?: string): void {
  setSentryUser(userId, orgId);
  setFaroUser(userId, orgId);
}

/**
 * Clear user context from both Sentry and Faro.
 * Call on logout.
 */
export function clearObservabilityUser(): void {
  clearSentryUser();
  clearFaroUser();
}
